enum EventName {
  galleryEngaged = 'Gallery Engaged'
}

export default EventName;
